const styles = (theme) => ({
  block: {
    display: "flex",
    flexDirection: "column",
    gap: 1.5,
    padding: "16px",
    borderRadius: "16px",
    backgroundColor: theme.palette.background.paper,
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    flexWrap: "wrap",
    gap: 1,
  },
  title: {
    fontWeight: 600,
    fontSize: "0.95rem",
  },
  description: {
    fontSize: "0.75rem",
    color: theme.palette.text.secondary,
    mt: 0.3,
  },
  actions: {
    display: "flex",
    alignItems: "center",
    gap: 0.3,
  },
  count: {
    height: 22,
    fontSize: "0.68rem",
    fontWeight: "bold",
    color: theme.palette.text.secondary,
    backgroundColor:
      theme.palette.mode === "dark"
        ? theme.palette.background.modalContrast
        : theme.palette.colors.black.lighter,
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(210px, 1fr))",
    gap: "10px",
  },
});

export default styles;
